import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=829a3360&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=ts&"
export * from "./Company.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829a3360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('829a3360')) {
      api.createRecord('829a3360', component.options)
    } else {
      api.reload('829a3360', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=829a3360&scoped=true&", function () {
      api.rerender('829a3360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/account/Company.vue"
export default component.exports